<script>
    import ProductReviewsRating from "@/components/product/ProductReviewsRating";

    export default {
        name: "ProductReviewsCard",
        components: { ProductReviewsRating },
        props: {
            review: Object,
        },
        data() {
            return {
                isOpened: false,
            };
        },
        computed: {
            reviewAuthor() {
                const replaced = this.review.author.replace(
                    "Пользователь предпочёл скрыть свои данные",
                    "Анонимный пользователь"
                );
                const stringArray = replaced.split(" ");
                if (stringArray.length === 3) {
                    stringArray.pop();
                }
                return stringArray.join(" ");
            },
            reviewSource() {
                if (this.review.source) {
                    return `/static/assets/reviews/brand-${this.review.source.toLowerCase()}.svg?v=021222`;
                }
                return false;
            },
            reviewDate() {
                let date = new Date(this.review.date.replace(/-/g, "/"));
                return date
                    ? date
                          .toLocaleDateString("ru-RU", {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                          })
                          .replace("г.", "")
                    : "";
            },
            textLength() {
                return (
                    (this.review.advantages?.length || 0) +
                    (this.review.disadvantages?.length || 0) +
                    (this.review.comment?.length || 0)
                );
            },
            isExpandable() {
                return this.textLength >= 500 && !this.isOpened;
            },
        },
        methods: {
            openReview() {
                this.isOpened = true;
            },
        },
    };
</script>

<template>
    <div class="review-card">
        <div class="review-card__header">
            <div class="review-card__rating">
                <product-reviews-rating :rating="review.rating"></product-reviews-rating>
            </div>
            <div class="review-card__name">{{ reviewAuthor }}</div>
            <div v-if="reviewSource" class="review-card__source">
                <img :src="reviewSource" :alt="review.source" />
            </div>
            <div class="review-card__date">{{ reviewDate }}</div>
        </div>

        <div class="review-card__content" :class="{ 'is-expandable': isExpandable }">
            <div v-if="review.advantages" class="review-card__section">
                <span class="review-card__title" v-if="review.disadvantages || review.comment">
                    Плюсы
                </span>
                <div class="review-card__text" v-html="review.advantages"></div>
            </div>

            <div v-if="review.disadvantages" class="review-card__section">
                <span class="review-card__title" v-if="review.advantages || review.comment">
                    Минусы
                </span>
                <div class="review-card__text" v-html="review.disadvantages"></div>
            </div>

            <div v-if="review.comment" class="review-card__section">
                <span
                    v-if="review.advantages || review.disadvantages"
                    class="review-card__title"
                >
                    Комментарий
                </span>
                <div class="review-card__text" v-html="review.comment"></div>
            </div>
        </div>

        <button v-if="isExpandable" class="review-card__more outline" @click="openReview">
            <span>Читать полностью</span>
            <svg width="8" height="8" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
                <path d="m8 2.77-4.04 3.9L0 2.85.86 2l3.1 3.02L7.14 2l.86.77Z" />
            </svg>
        </button>
    </div>
</template>

<style lang="scss">
    .review-card__header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 30px;
        }
    }

    .review-card__name {
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        @include bp($bp-desktop-sm) {
            max-width: 290px;
            margin-bottom: 0;
            font-size: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .review-card__source {
        margin-bottom: 5px;
        img {
            height: 14px;
        }
        @include bp($bp-desktop-sm) {
            order: 1;
            margin-bottom: 0;
            img {
                height: 20px;
            }
        }
    }

    .review-card__rating {
        width: 100%;
        margin-bottom: 10px;
        @include bp($bp-desktop-sm) {
            width: auto;
            margin-bottom: 0;
            margin-right: 20px;
        }
    }

    .review-card__date {
        width: 100%;
        color: #acacac;
        font-size: 12px;
        line-height: 16px;
        @include bp($bp-desktop-sm) {
            width: auto;
            margin-right: 20px;
            margin-left: auto;
            font-size: 16px;
            line-height: 18px;
        }
    }

    .review-card__content {
        position: relative;
        max-height: 1500px;
        transition: max-height 0.3s ease-in;
        overflow: hidden;
        &.is-expandable {
            max-height: 200px;
            &::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 65px;
                background: var(--product-gradient-block);
            }
        }
    }

    .review-card__section {
        &:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    .review-card__title {
        display: block;
        margin-bottom: 5px;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
    }

    .review-card__text {
        font-size: 12px;
        line-height: 16px;
        white-space: pre-line;
        @include bp($bp-desktop-sm) {
            font-size: 16px;
            line-height: 22px;
        }
    }

    .review-card__more {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 600;
        line-height: 12px;
        transition: color 0.2s ease-in;
        &:hover {
            color: #808080;
            span {
                border-bottom-color: #808080;
            }
        }
        span {
            border-bottom: 1px solid transparent;
            transition: border-bottom-color 0.2s ease-in;
        }
        svg {
            @include box(8px);
            margin-left: 5px;
            fill: currentColor;
        }
        @include bp($bp-desktop-sm) {
            margin-top: 20px;
            font-size: 16px;
            line-height: 16px;
            svg {
                @include box(12px);
                margin-left: 10px;
            }
        }
    }
</style>
